export const ClubNotFound = () => <h2>Club not found</h2>;
